import { closeH5Link } from "@/utils/utils";
export default {
  name: "BaseInfo",
  props: {
    data: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    client: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    ostype: {
      type: String,
      default: function _default() {
        return '';
      }
    }
  },
  data: function data() {
    return {
      loading: false
    };
  },
  computed: {},
  mounted: function mounted() {},
  created: function created() {},
  methods: {
    close: function close() {
      closeH5Link(ostype);
    }
  }
};